module.exports = __webpack_public_path__ + "img/dp-sy-bm4.c6e3be14.png";